import { cn } from '../../lib/utils';
import { HorizontalStack } from './Stack';

export interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  label?: string;
  className?: string;
}

export function Pagination({
  page,
  totalPages,
  onPageChange,
  label,
  className,
}: PaginationProps) {
  const buttonClassName =
    'inline-flex h-8 items-center justify-center rounded border border-border/50 bg-background px-3 text-[11px] font-bold uppercase tracking-tight text-foreground transition-all hover:border-border hover:bg-muted/30 disabled:cursor-not-allowed disabled:opacity-40';
  return (
    <HorizontalStack
      gap={4}
      className={cn(
        'justify-between rounded-lg border border-border/50 bg-muted/10 px-4 py-2',
        className
      )}
    >
      <div className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground/80">
        {label || `Page ${page} of ${totalPages}`}
      </div>
      <HorizontalStack gap={1}>
        <button
          type="button"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className={buttonClassName}
        >
          Previous
        </button>
        <div className="h-4 w-px bg-border/40 mx-1" />
        <button
          type="button"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          className={buttonClassName}
        >
          Next
        </button>
      </HorizontalStack>
    </HorizontalStack>
  );
}
